import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConstantsService } from '../constants.service';

@Injectable({
	providedIn: 'root'
})
export class DomicileService {

	constructor(private readonly http : HttpClient, private readonly constantsService : ConstantsService) { }

	getTierList(periodId): Observable<any> {
		return this.http.get<any>(`${this.constantsService.baseAPIURL}/gi/getTiersByPeriodId/${periodId}`, this.constantsService.httpCustomOptions)
			.pipe(

				catchError(this.handleError)
			);
	}

	getRoundList(periodId, tierId): Observable<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/gi/getRounds/${periodId}/${tierId}`, this.constantsService.httpCustomOptions)
			.pipe(

				catchError(this.handleError)
			);
	}

	getGridData(periodId, tierId, round, dataArr): Observable<any> {
		const InData  = {
			P_PeriodID: periodId,
			P_TierID: tierId,
			P_Round: round,
			P_DomicileList: dataArr
		}

		return this.http
			.post(`${this.constantsService.baseAPIURL}/gikpi/getDomicileGroupIKPI`, InData, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(

				catchError(this.handleError)
			);
	}
	getDomicileList(periodId, tierId, round): Observable<any> {

		return this.http
			.get(`${this.constantsService.baseAPIURL}/gikpi/getDomicileGroupIKPI/loadDomicileList?P_PeriodID=${periodId}&P_TierID=${tierId}&P_Round=${round}`, this.constantsService.httpCustomOptions)
			.pipe(

				catchError(this.handleError)
			);
	}
	private handleError(error: HttpErrorResponse): Observable<never> {
		return throwError(() => error.message || 'Server Error');
	}
}
